/*
 * Brand landing sections (sections/brand-*.liquid)
 * - Scroll reveals for [data-bl-reveal]
 * - Fabric rail arrows
 * - Mobile booking bar
 * Uses IntersectionObserver only; no window scroll listeners.
 */
(function() {
  if (window.BrandLanding) return;
  window.BrandLanding = true;

  var root = document.documentElement;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var hasIO = 'IntersectionObserver' in window;

  function initReveal(scope) {
    var items = scope.querySelectorAll('[data-bl-reveal]:not(.is-visible)');
    if (!items.length) return;

    if (!root.classList.contains('bl-motion') || !hasIO) {
      items.forEach(function(el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

    items.forEach(function(el) { observer.observe(el); });
  }

  function initRail(scope) {
    scope.querySelectorAll('[data-bl-rail]').forEach(function(rail) {
      var track = rail.querySelector('[data-bl-rail-track]');
      var prev = rail.querySelector('[data-bl-rail-prev]');
      var next = rail.querySelector('[data-bl-rail-next]');
      if (!track || !prev || !next) return;

      function step() {
        var card = track.firstElementChild;
        if (!card) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      function go(direction) {
        track.scrollBy({
          left: direction * step(),
          behavior: reduceMotion.matches ? 'auto' : 'smooth'
        });
      }

      prev.addEventListener('click', function() { go(-1); });
      next.addEventListener('click', function() { go(1); });

      // Disable an arrow when its end card is fully in view
      var first = track.firstElementChild;
      var last = track.lastElementChild;
      if (!hasIO || !first || !last) return;

      var ends = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          var atEnd = entry.intersectionRatio > 0.98;
          if (entry.target === first) prev.disabled = atEnd;
          if (entry.target === last) next.disabled = atEnd;
        });
      }, { root: track, threshold: [0, 0.98, 1] });

      ends.observe(first);
      ends.observe(last);
    });
  }

  function initBar() {
    var bar = document.querySelector('[data-bl-bar]');
    var hero = document.querySelector('#MainContent > .shopify-section');
    if (!bar || !hero || !hasIO) return;

    // Hide while the first section (the banner), the booking section or the footer is on screen
    var blockers = [hero];
    var book = document.querySelector('[data-bl-book]');
    var footer = document.querySelector('footer, [data-section-type="footer"]');
    if (book) blockers.push(book);
    if (footer) blockers.push(footer);

    var visible = new Set();

    function update() {
      var show = visible.size === 0;
      bar.classList.toggle('is-shown', show);
      if (show) {
        bar.removeAttribute('inert');
        bar.removeAttribute('aria-hidden');
      } else {
        bar.setAttribute('inert', '');
        bar.setAttribute('aria-hidden', 'true');
      }
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) visible.add(entry.target);
        else visible.delete(entry.target);
      });
      update();
    });

    blockers.forEach(function(el) { observer.observe(el); });
  }

  function init(scope) {
    initReveal(scope);
    initRail(scope);
  }

  function start() {
    init(document);
    initBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Theme editor: sections re-render in place
  document.addEventListener('shopify:section:load', function(event) {
    init(event.target);
  });
})();
